import React from 'react';
import moment from 'moment';
import { InputLabelContainer } from '../../label/containers/input-label.container';
import { InputErrorContainer } from '../../error/containers/input-error.container';

export function DateInputComponent({
  label,
  value,
  onValueChange,
  isDisabled,
  error,
  isDateTimePicker,
  noMargin,
  onClick,
  isRequired,
}: any) {
 
  const formattedDate = value ? moment(value).format('YYYY-MM-DD') : '';
  const formattedDateTimePicker = value ? moment(value).format('YYYY-MM-DDTHH:mm') : '';

  return (
     <div className={`mb-3 ${noMargin ? '' : 'input-wrapper-overrider'}`} onClick={(event) => onClick && onClick(event)}>
      <InputLabelContainer
        isRequired={isRequired}
        label={label}
      />
      {isDateTimePicker ? (
        <input
          type="datetime-local"
          className={`appearance-none block bg-white border border-gray-300 rounded-md py-2 px-3 leading-tight focus:outline-none focus:ring-blue-500 focus:border-blue-500 w-60 ${isDisabled ? 'bg-gray-100 cursor-not-allowed' : ''
            } ${Boolean(error) ? 'border-red-500' : ''}`}
          onChange={(e) => onValueChange(e.target.value)}
          disabled={isDisabled}
          value={formattedDateTimePicker}
        />
      ) : (
        <input
          type="date"
          className={`appearance-none block bg-white border border-gray-300 rounded-md py-2 px-3 leading-tight focus:outline-none focus:ring-blue-500 focus:border-blue-500 w-60 ${isDisabled ? 'bg-gray-100 cursor-not-allowed' : ''
            } ${Boolean(error) ? 'border-red-500' : ''}`}
          onChange={(e) => onValueChange(e.target.value)}
          disabled={isDisabled}
          value={formattedDate}
        />
      )}
      <InputErrorContainer error={error} />
    </div>
  );
}
